import React from 'react';
import { Alert, Button } from '@mui/material';
import type { Vorlagensperre } from '../../hooks/useVorlagensperre';
import {
  anderesFensterText,
  anderesFensterVerlorenText,
  fremdeSperreText,
  SPERRE_FREI_KNOPF,
  SPERRE_FREI_TEXT,
  verloreneSperreText,
  ZWEITES_FENSTER_WEITER,
} from '../../services/vorlagensperreTexte';

interface Props {
  sperre: Vorlagensperre;
}

// RITA-1541: Band direkt unter der Titelzeile (Entwurf v2, Bilder 1–3 und 5). Gelb: jemand anderes
// bearbeitet bzw. das eigene andere Fenster; rot: die eigene Bearbeitung ist verloren; grün: die
// Vorlage ist wieder frei. Es gibt keinen Knopf zum Übernehmen fremder Bearbeitungen.
export default function VorlagenSperrhinweis({ sperre }: Props) {
  const { status, halter } = sperre;
  if (status === 'frei') {
    return (
      <Alert
        severity="success"
        data-testid="vertragsvorlage-sperre"
        data-sperrstatus={status}
        sx={{ mt: 1, alignItems: 'center' }}
        action={
          <Button color="inherit" size="small" variant="outlined" onClick={sperre.aktuellenStandLaden}>
            {SPERRE_FREI_KNOPF}
          </Button>
        }
      >
        {SPERRE_FREI_TEXT}
      </Alert>
    );
  }
  if (!halter) return null;
  if (status === 'fremd' || status === 'verloren') {
    return (
      <Alert
        severity={status === 'fremd' ? 'warning' : 'error'}
        icon={<span aria-hidden="true">🔒</span>}
        data-testid="vertragsvorlage-sperre"
        data-sperrstatus={status}
        sx={{ mt: 1 }}
      >
        {status === 'fremd' ? fremdeSperreText(halter) : verloreneSperreText(halter)}
      </Alert>
    );
  }
  if (status === 'anderesFenster' || status === 'anderesFensterVerloren') {
    // Nur das Fenster, das „Nur lesen“ gewählt hat, bietet „Hier weiterbearbeiten“; das alte Fenster, dessen
    // Bearbeitung anderswo fortgesetzt wurde, zeigt laut Entwurf v2 nur den Hinweis.
    return (
      <Alert
        severity="warning"
        icon={<span aria-hidden="true">🔒</span>}
        data-testid="vertragsvorlage-sperre"
        data-sperrstatus={status}
        sx={{ mt: 1, alignItems: 'center' }}
        action={
          status === 'anderesFenster' ? (
            <Button color="inherit" size="small" variant="outlined" onClick={sperre.hierWeiterbearbeiten}>
              {ZWEITES_FENSTER_WEITER}
            </Button>
          ) : undefined
        }
      >
        {status === 'anderesFenster' ? anderesFensterText(halter) : anderesFensterVerlorenText(halter)}
      </Alert>
    );
  }
  return null;
}
